import { API_URL } from "@/constants/envVariables";
import { handleSearchParams } from "@/api/handleSearchParams";
import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";
import { AuditLogSearchParams } from "@/types";

export const getAuditLogExport = async (
  token: string,
  searchParams?: AuditLogSearchParams,
): Promise<void> => {
  const params = handleSearchParams(searchParams);

  const response = await fetch(`${API_URL}/audit-logs/export${params}`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      ...buildAuthHeaders(token),
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const contentDisposition = response.headers.get("content-disposition") ?? "";
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
  const fallbackName = `audit_logs_${new Date().toISOString().split("T")[0]}.csv`;
  const filename = decodeURIComponent(match?.[1] ?? match?.[2] ?? fallbackName);

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
